import { Dispatch, SetStateAction } from 'react';
import { useHome } from './useHome';
import CompensationRequestForm from '../../components/CompensationRequestForm/CompensationRequestForm';
import Confirmation from '../../components/Confirmation/Confirmation';

interface Props {
    setActiveMenuIndex: Dispatch<SetStateAction<number>>;
}

const Home = ({setActiveMenuIndex}: Props) => {
    const { 
        compensationVouchers,
        isDeviceOffline,
        showConfirmation,
        validationError,
        handleOnClickNewForm,
        setCompensationVouchers,
        setShowConfirmation,
        setValidationError,
    } = useHome({setActiveMenuIndex});

    return (
        <div className="c-page" id="c-page">
            {showConfirmation ? (
                <Confirmation
                    compensationVouchers={compensationVouchers}
                    isDeviceOffline={isDeviceOffline}
                    validationError={validationError}
                    handleOnClickNewForm={handleOnClickNewForm}                   
                />
            ) : (
                <CompensationRequestForm
                    compensationVouchers={compensationVouchers}                         
                    isDeviceOffline={isDeviceOffline}
                    validationError={validationError}
                    setCompensationVouchers={setCompensationVouchers}
                    setShowConfirmation={setShowConfirmation}
                    setValidationError={setValidationError}
                />
            )}
        </div> 
    );
};

export default Home;

